

import React,{useEffect,useState,useRef} from 'react'
import MainRouter from './navigation/MainRouter'
import Alert from './components/Alert'
// Dev sandbox import — guarded usage below is tree-shaken in production builds.
import ModalBrowserSandbox from 'controller/dev/ModalBrowserSandbox'

// import { getContentPath } from './AssetManager'
import Globals from './Globals'
// import M from './utils/M'
import LoadingBG from 'assets/intro-bg.webp'
import { logo as Logo } from 'config'
import gsap from 'gsap/gsap-core'
import { setUser, setNarratives, setNarrativeTree } from 'store/actions'
import { fetchNarratives, fetchNarrativeGroups } from './AssetManager'
import { connect } from "react-redux";
import history from 'system/navigation/MainRouterHistory'

let  Main=(props)=>{
  const deviceSpan = useRef();
  const [alert,setAlert]=useState()
  const [toast,setToast]=useState(null)

  const [showBG,setShowBG]=useState(Globals.instance().iosOverlay === true ?false:true)

  const refEle=useRef()

  // Non-blocking, self-dismissing toast (e.g. slow-connection heads-up). Kept
  // separate from the modal Alert so it never blocks an unattended kiosk.
  useEffect(()=>{
    let timer
    const onToast=(evt)=>{
      setToast(evt.detail && evt.detail.message)
      if(timer) clearTimeout(timer)
      timer=setTimeout(()=>setToast(null), 6000)
    }
    window.addEventListener('show-toast', onToast)
    return ()=>{ window.removeEventListener('show-toast', onToast); if(timer) clearTimeout(timer) }
  },[])

  // Persistent self-heal: when connectivity is restored (offline->online),
  // re-fetch the narrative list + groups so the home repopulates without a
  // reload. Lives here (Main is always mounted) rather than Launch, which
  // unmounts after the initial load and would miss a later recovery.
  useEffect(()=>{
    const onConnectivity = async (isOnline)=>{
      if(!isOnline) return
      if(!(Globals.instance().electron || Globals.instance().ios)) return
      console.log('[conn] connectivity restored - refreshing narratives')
      try{
        const list = await fetchNarratives()
        if(list) props.setNarratives(list)
        const groups = await fetchNarrativeGroups()
        if(groups) props.setNarrativeTree(groups)
      }catch(err){ console.log('[conn] narrative refresh failed', err && err.message) }
    }
    Globals.instance().events.on('internet-status-changed', onConnectivity)
    return ()=>{ Globals.instance().events.off('internet-status-changed', onConnectivity) }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])


  useEffect(()=>{

    const resize=()=>{
  

      let ele = document.getElementById('root');

      let l= ((1024/768) - (ele.clientWidth/ele.clientHeight))/((1024/768)-(1920/1080))
      if(l>1)l=1
      if(l<0)l=0
      document.documentElement.style.setProperty('--lerpAspect', l);
      
      let sx =  ele.clientWidth/ (1024+(l*(1920-1024)))
      let sy =   ele.clientHeight/(768+(l*(1080-768)))
      let s = sx<sy ? sx:sy


      if (deviceSpan.current && Globals.instance().device_width && Globals.instance().device_height) {
        // let width = ele.clientWidth/Globals.instance().device_width;
        // let height = ele.clientHeight/Globals.instance().device_height;
        let width = Globals.instance().device_width;
        let height = Globals.instance().device_height;
        deviceSpan.current.style.maxWidth = width * 1 + "px";
        deviceSpan.current.style.maxHeight = height * 1 + "px";
        console.log('device width height', width, height)
      } else {
        deviceSpan.current.style.maxWidth = "auto";
        deviceSpan.current.style.maxHeight = "auto";
      }
    
      
      // console.log('lerpScale', ele.clientHeight, ele.clientWidth, sx, sy)
      // document.documentElement.style.setProperty('--lerpScale', s);
      document.documentElement.style.setProperty('--lerpScale', 1);
      // --lerpScale stays pinned at 1: it multiplies every scaleValue() call in
      // the app and was switched off deliberately. --uiScale exposes the same
      // computation for the few rules that opt in (menu type), measured against
      // the aspect-interpolated reference rather than a fixed 1920x1080 -- which
      // matters on iPad, where the reference IS 1024x768 and a straight
      // window/HD ratio would shrink type that is already sized for the device.
      document.documentElement.style.setProperty('--uiScale', s);
      
      if(ele.clientWidth/ele.clientHeight > 1920/1080){
        document.documentElement.style.setProperty('--scaleHD', ele.clientHeight/1080);
      }
      else{
        document.documentElement.style.setProperty('--scaleHD', ele.clientWidth/1920); 
      }
      if(ele.clientWidth/ele.clientHeight > 1024/768){
        document.documentElement.style.setProperty('--scaleiPad', ele.clientHeight/768);
      }
      else{
        document.documentElement.style.setProperty('--scaleiPad', ele.clientWidth/1024); 
      }

      
      window.addEventListener('alert',(evt)=>{
        console.log(evt)
          setAlert(evt.detail)
      })

      window.addEventListener('close-alert',()=>{  setAlert(null)})

      

      var map = {}; // You could also use an array
      document.addEventListener('keydown',(evt)=>{
        map[evt.key] = true
        if(!Globals.instance().ios){
          if((map['f'] && map['Control'])){
            map[evt.key] = false
            if(!Globals.instance().electron)Globals.instance().toggleFullscreen() 
          }      
        }
        
        // Show alert when reloading in offline mode with no internet
        if(map['r'] && (map['Control'] || map['Meta'])) {
          if(Globals.instance().offlineMode){
            Globals.instance().showAlert('No Internet Connection', 
              '<span style="text-align:center"><p>You are reloading the app without an internet connection.</p></span>');
            map[evt.key] = false;
          }
        } 
      })  
      document.addEventListener('keyup',(evt)=>{
        map[evt.key] = false
      })
      const onHideEvent=()=>{ setShowBG(false);window.removeEventListener('hide-initial-bg',onHideEvent)}
      window.addEventListener('hide-initial-bg',onHideEvent)
      
      

      //listen for controller events
      const onControllerEvent=(evt)=>{
        
        console.log("Controller event", evt)
        let detail = evt.detail
        if(!detail)return
        if(detail.event==='set-user'){
          console.log(detail.user)
          let user = detail.user
          console.log("got user " + user.username)
          props.setUser(user)
        }
        if(detail.event ==='serverIP'){
          console.log('serverIP from onControllerEvent: '+ detail.path)
          Globals.instance().serverIP = detail.path;
        }
        if(detail.event ==='ping'){
          console.log('onControllerEvent: ping')
          Globals.instance().controllerPing = true;
        }

        if(detail.event ==='downloaded'){
          console.log('onControllerEvent: downloaded ' + detail.downloaded)
          if (detail.downloaded) {
            
            localStorage.setItem('expo.downloaded', detail.downloaded)
  
          }
  
        }
        if(detail.event ==='loadState'){
          console.log('onControllerEvent: loadState ' + detail.nid, detail.state)
  
  
        }
        
        
      }
      
      const onServerEvent=(evt)=>{
        
        console.log("Server event", evt)
        let detail = evt.detail
        if(!detail)return
        if(detail.event==='navigate'){
          console.log('navigate to path : '+Globals.instance().getRoute(detail.command))

          let arrURL = detail.command.split('?')
          if(arrURL.length===1)
            history.push(Globals.instance().getRoute(detail.command))
          else {
            console.log("params")
            history.push({pathname:arrURL[0], search:'?'+arrURL[1]})
          }
        }
        if(detail.event ==='serverIP'){
          console.log('serverIP from onServerEvent: '+ detail.path)
          Globals.instance().serverIP = detail.path;
        }

        
      }

      if(Globals.instance().controllerApp){
        window.removeEventListener('controller-event',onControllerEvent)
        window.addEventListener('controller-event', onControllerEvent)
      }
      
      if(Globals.instance().serverApp){
        window.removeEventListener('server-event',onServerEvent)
        window.addEventListener('server-event',onServerEvent)
      }

     
  }

    setTimeout(() => {
      resize()
    }, 300);
    

    
    window.addEventListener('resize',()=>{ resize() })

  }, []);

  // useEffect(() => {
  //   console.log('user on main', Globals.instance().store)
  // }, [])


  function onLoadBG(){
    gsap.to(refEle.current,{opacity:1,duration:0.25})
  }
  // Globals.instance().device_width

    // Dev sandbox bypass: when running CRA dev server with `?sandbox=modal-browser`,
    // swap the router for the modal browser sandbox. Stays inside the deviceSpan
    // wrapper so resize/refs initialize normally. Tree-shaken from production builds.
    const sandboxMode = process.env.NODE_ENV === 'development' &&
        typeof window !== 'undefined' &&
        window.location.search.includes('sandbox=modal-browser')

    return(
        <span ref={deviceSpan} class="deviceSpan">
            <div id="main" className="fullscreen">
            { showBG && (
            <div className={`fullscreen fcenter background`} ref={refEle}  style={{opacity:0}}>

            </div>
            )}
            { sandboxMode ? <ModalBrowserSandbox /> : <MainRouter /> }
            { alert &&  (<Alert alert={alert}></Alert>)}
            { toast && (
              <div
                onClick={()=>setToast(null)}
                style={{
                  position:'fixed', left:'50%', bottom:'6%', transform:'translateX(-50%)',
                  maxWidth:'80%', padding:'12px 20px', borderRadius:'8px',
                  background:'rgba(20,20,20,0.92)', color:'#fff', fontSize:'15px',
                  lineHeight:1.4, textAlign:'center', zIndex:99999, cursor:'pointer',
                  boxShadow:'0 4px 16px rgba(0,0,0,0.4)', pointerEvents:'auto'
                }}
              >
                {toast}
              </div>
            )}


          </div>
        </span>

    )
}




function mapDispatchToProps(dispatch) {
  return {
    setUser: val => dispatch(setUser(val)),
    setNarratives: val => dispatch(setNarratives(val)),
    setNarrativeTree: val => dispatch(setNarrativeTree(val)),
  };
}


export default connect(undefined, mapDispatchToProps,undefined,{forwardRef:true})(Main)

    // <img className={`fullscreen cover`} src={LoadingBG} alt="" onLoad={onLoadBG}></img>
    //             <img src={Logo} style={{'position':'absolute','left':'7%','width':'12%','bottom':'9.2%', "display": "none"}} alt=""></img>